<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                    'bg-gray-600': sharedService.userTheme === 'dark',
                    'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div>
            <h4 *ngIf="editMode == 'list'">Specialty List </h4>
            <h4 *ngIf="editMode == 'edit'">T CD : {{item.t_CD}}</h4>
            <h4 *ngIf="editMode == 'add'">Add New Specialty Category</h4>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button *ngIf="editMode == 'list'" matTooltip="Add New" (click)="add()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Save" (click)="save()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode == 'edit'" matTooltip="Delete" (click)="delete()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

  <!-- List Mode -->
  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col" *ngIf="list.length !== 1">
          <div class="flex flex-row">
            <mat-form-field class="w-1/4">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full" matSortActive="majorCat" matSortDirection="asc">
                <ng-container matColumnDef="t_CD">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>T CD</th>
                  <td mat-cell *matCellDef="let category">{{category.t_CD}}</td>
                </ng-container>
                <ng-container matColumnDef="specialty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Specialty</th>
                  <td mat-cell *matCellDef="let category">{{category.majorCat}}</td>
                </ng-container>
                <ng-container matColumnDef="subSpecialty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Specialty</th>
                  <td mat-cell *matCellDef="let category">{{category.licAbbrev}}</td>
                </ng-container>
                <ng-container matColumnDef="pt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>PT</th>
                  <td mat-cell *matCellDef="let category">{{category.pt}}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header disabled>Actions</th>
                  <td mat-cell *matCellDef="let category">
                    <button mat-icon-button matTooltip="Edit" (click)="edit(category)"
                      [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">edit</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

  <!-- New / Edit Mode -->
  <form [formGroup]="formGroup">
    <div class="flex flex-col" *ngIf="editMode !== 'list'">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                    'bg-gray-600': sharedService.userTheme === 'dark',
                    'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-col">

          <div class="flex flex-row gap-4">
            <div class="flex flex-row flex-wrap w-full sm:flex-col">
              <mat-card-content class="w-1/2">
                <div class="flex flex-col mt-4 w-full">

                  <mat-form-field *ngIf="editMode == 'add'">
                    <mat-label>T CD</mat-label>
                    <input matInput formControlName="T_CD">
                    <mat-error *ngIf="formGroup.get('T_CD').invalid">
                      Required field.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Specialty</mat-label>
                    <input matInput formControlName="MajorCat">
                    <mat-error *ngIf="formGroup.get('MajorCat').invalid">
                      Required field / 10 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Sub Specialty</mat-label>
                    <input matInput formControlName="LicAbbrev">
                    <mat-error *ngIf="formGroup.get('LicAbbrev').invalid">
                      Required field / 10 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>PT</mat-label>
                    <mat-select formControlName="PT">
                      <mat-option value=""></mat-option>
                      <mat-option value="Y">Y</mat-option>
                      <mat-option value="N">N</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formGroup.get('PT').invalid">
                      Required
                    </mat-error>
                  </mat-form-field>
  
                </div>
              </mat-card-content>
            </div>
          </div>


        </div>
      </mat-card>

    </div>
  </form>
</div>

<!-- <div class="row">{{list | json}}</div> -->